export default __webpack_public_path__ + "static/media/NeuroDiversityLogo.6c2bd3d4.svg";